import { defineComponent, computed, ref, PropType } from "vue";

export default defineComponent({
  name: "cs-input",
  props: {
    modelValue: {
      type: [String, Number] as PropType<string | number>,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    inputType: {
      type: String,
      default: "text",
      validator: (value: string) => ["text", "number"].includes(value),
    },
    format: {
      type: String,
      default: "text",
      validator: (value: string) =>
        [
          "price",
          "number",
          "integer",
          "decimal",
          "qty",
          "text",
          "percentage",
        ].includes(value),
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const errorMessage = ref<string | null>(null);

    const formattedValue = computed(() => {
      if (props.format === "price") {
        return props.modelValue
          ? parseFloat(props.modelValue as string).toFixed(2)
          : "";
      } else if (props.format === "percentage") {
        return props.modelValue ? `${props.modelValue}%` : "";
      }
      return props.modelValue;
    });

    const inputId = computed(
      () => `input-${Math.random().toString(36).substr(2, 9)}`
    );

    const validateInput = (value: string): boolean => {
      switch (props.format) {
        case "integer":
          return /^-?\d*$/.test(value);
        case "decimal":
          return /^-?\d*\.?\d*$/.test(value);
        case "price":
          return /^-?\d*\.?\d*$/.test(value);
        case "qty":
          return /^-?\d*$/.test(value);
        case "percentage":
          return /^-?\d*$/.test(value);
        default:
          return true;
      }
    };

    const onInput = (event: Event) => {
      let value = (event.target as HTMLInputElement).value;

      if (!validateInput(value)) {
        event.preventDefault();
        errorMessage.value = `Invalid ${props.format} format`;
        return;
      }

      errorMessage.value = null;

      if (props.format === "percentage") {
        value = value.replace("%", "");
      }

      emit("update:modelValue", value);
    };

    const onBlur = (event: Event) => {
      let value = (event.target as HTMLInputElement).value;

      if (props.format === "price" && value) {
        value = parseFloat(value).toFixed(2);
        emit("update:modelValue", value);
      } else if (props.format === "percentage" && value) {
        value = `${value}%`;
        emit("update:modelValue", value);
      }
    };

    return {
      formattedValue,
      inputId,
      errorMessage,
      onInput,
      onBlur,
    };
  },
});
